import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, OnChanges, SimpleChanges } from '@angular/core';
import { CommonService } from '../../service/common/common.service';
import { ScheduleService } from '../../service/schedule/schedule.service';

@Component({
  selector: 'time-select',
  templateUrl: './time-select.component.html',
  styleUrls: ['./time-select.component.less'],
})
export class TimeSelectComponent implements OnInit, OnChanges {
  @Input() type = 1; // 初试： 1， 复试：2
  @Input() scheduleDay = []; // 面试日程天
  @Input() scheduleTime = []; // 面试日程小时
  @Input() scheduleInterviewer = []; // 面试官
  @Input() recruit_id; // 招聘记录id
  @Output() check = new EventEmitter();

  interviewerAll = true; // 全部面试官
  indeterminate = false; // 全部面试官待定
  interviewerName = []; // 面试官名称
  interviewerId = []; // 面试官id
  interviewerList = [
    { id: 1, name: '都是', checked: true },
    { id: 2, name: '第三方', checked: true },
    { id: 3, name: '大树', checked: true },
  ]; // 面试官列表
  interviewerVisible = false; // 面试官下拉
  interviewDateIndex = 0; // 面试官时间段索引
  interviewDateArr = [
    [new Date(), new Date(new Date().setDate(new Date().getDate() + 6))],
    [new Date(new Date().setDate(new Date().getDate() + 7)), new Date(new Date().setDate(new Date().getDate() + 13))],
    [new Date(new Date().setDate(new Date().getDate() + 14)), new Date(new Date().setDate(new Date().getDate() + 20))],
    [new Date(new Date().setDate(new Date().getDate() + 21)), new Date(new Date().setDate(new Date().getDate() + 27))],
  ]; // 面试官时间段

  objectKeys = Object.keys;
  selectDay = [];
  gridTime: Array<string> = []; // 每天 日期选项
  gridDate: Array<string> = []; // 日期数据
  gridDay: Array<object> = []; // 表格头部日期数据\
  closeTip: boolean = false;
  countData: object = {};
  scheduleSourceData: Array<object> = [];
  scheduleData: Array<object> = [];
  create_schedule: Array<object> = []; // 新增的日程
  del_schedule_id: Array<number> = []; // 移除的日程id
  moveGridStatus: boolean = true; // 本次选择时，格子的状态
  disableEdit: boolean = false;
  contact: string = '';

  timerI = null;
  dateI = null;

  checkData: any = {}; // 选中数据
  constructor(private common: CommonService, private basisService: ScheduleService) {
    this.getEveryDay();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['scheduleDay']) {
      this.gridDay = [...this.scheduleDay];
      const _gridDate = [];
      for (const i of this.scheduleDay) {
        _gridDate.push(i['date']);
      }
      this.gridDate = _gridDate;
    }
    if (changes['scheduleTime']) {
      this.scheduleSourceData = JSON.parse(JSON.stringify(this.scheduleTime));
      const _gridTime = [];
      this.scheduleTime.map((item) => {
        _gridTime.push(item.timer);
      });
      this.gridTime = [..._gridTime];
      this.getCountData(this.scheduleTime);
      this.formatSchedule(this.scheduleTime);
    }
    if (changes['scheduleInterviewer']) {
      this.formatInterviewer(this.scheduleInterviewer);
      this.interviewerId = [];
      this.interviewerId = [];
      const _interviewerName = [];
      const _interviewerId = [];
      for (const i of this.interviewerList) {
        if (i.checked) {
          _interviewerName.push(i.name);
          _interviewerId.push(i.id);
        }
      }
      this.interviewerName = [..._interviewerName];
      this.interviewerId = [..._interviewerId];
    }
  }

  ngOnInit(): void {}
  handleClose(i: any): void {
    this.checkData.name.splice(i, 1);
    this.checkData.interviewer_uid.splice(i, 1);
    this.checkData.schedule_id.splice(i, 1);
    if (this.checkData.name.length == 0) {
      this.checkData = {};
    }
    this.check.emit({ event: 'check', target: this.checkData });
  }
  // 选择面试官 全部
  interviewerAllChecked(): void {
    this.indeterminate = false;
    if (this.interviewerAll) {
      this.interviewerList = this.interviewerList.map((item) => ({
        ...item,
        checked: true,
      }));
    } else {
      this.interviewerList = this.interviewerList.map((item) => ({
        ...item,
        checked: false,
      }));
    }
  }
  // 选择面试官 单个
  interviewerChecked(): void {
    if (this.interviewerList.every((item) => !item.checked)) {
      this.interviewerAll = false;
      this.indeterminate = false;
    } else if (this.interviewerList.every((item) => item.checked)) {
      this.interviewerAll = true;
      this.indeterminate = false;
    } else {
      this.interviewerAll = false;
      this.indeterminate = true;
    }
  }
  // 选择面试官重置
  interviewerVisibleClear(): void {
    for (const i of this.interviewerList) {
      i.checked = false;
    }
    this.interviewerAll = false;
    this.indeterminate = false;
  }
  // 选择面试官确认
  interviewerVisibleChange(): void {
    if (!this.interviewerVisible) {
      if (this.interviewerList.every((item) => !item.checked)) {
        this.interviewerName = [];
        this.interviewerId = [];
        this.checkData = {};
        this.check.emit({ event: 'check', target: this.checkData });
        return;
      }
      this.interviewerName = [];
      this.interviewerId = [];
      for (const i of this.interviewerList) {
        if (i.checked) {
          this.interviewerName.push(i.name);
          this.interviewerId.push(i.id);
        } else {
          if (this.checkData.interviewer_uid != undefined) {
            if (this.checkData.interviewer_uid.indexOf(i.id) != -1) {
              this.checkData.interviewer_uid.splice(this.checkData.interviewer_uid.indexOf(i.id), 1);
              this.checkData.schedule_id.splice(this.checkData.interviewer_uid.indexOf(i.id), 1);
              this.checkData.name.splice(this.checkData.interviewer_uid.indexOf(i.id), 1);
            }
          }
        }
      }
      if (this.checkData.name != undefined) {
        if (this.checkData.name.length == 0) {
          this.checkData = {};
        }
        this.check.emit({ event: 'check', target: this.checkData });
      }
      this.getSchedule();
    }
  }
  // 选择时间段
  rClick(): void {
    if (this.interviewDateIndex == 3) {
      return;
      // this.interviewDateIndex = 0 - 1;
    }
    this.interviewDateIndex++;

    this.getEveryDay();
    this.getSchedule();
  }
  // 选择时间段
  lClick(): void {
    if (this.interviewDateIndex == 0) {
      return;
      // this.interviewDateIndex = 3 + 1;
    }
    this.interviewDateIndex--;

    this.getEveryDay();
    this.getSchedule();
  }
  private getSchedule(): void {
    this.basisService
      .getScheduleList({
        recruit_id: this.recruit_id,
        interviewer_ids: this.interviewerId.join(','),
        type: this.type,
        start_time: this.common.date(this.interviewDateArr[this.interviewDateIndex][0], 'Y-m-d'),
        end_time: this.common.date(this.interviewDateArr[this.interviewDateIndex][1], 'Y-m-d'),
      })
      .then((res) => {
        this.scheduleDay = res.date_week;
        this.scheduleTime = res.interview_schedule;

        this.gridDay = [...this.scheduleDay];
        const _gridDate = [];
        for (const i of this.scheduleDay) {
          _gridDate.push(i['date']);
        }
        this.gridDate = _gridDate;

        this.scheduleSourceData = JSON.parse(JSON.stringify(this.scheduleTime));
        const gridTime = [];
        this.scheduleTime.map((item) => {
          gridTime.push(item.timer);
        });
        this.gridTime = [...gridTime];
        this.getCountData(this.scheduleTime);
        this.formatSchedule(this.scheduleTime);
      });
  }
  /**
   * 格式化面试官数据 使其符合人员选择组件数据格式
   *
   */
  private formatInterviewer(data: any): void {
    const _interviewerList = [];
    for (const i of data) {
      _interviewerList.push({
        id: i.interviewer_uid,
        name: i.username,
        checked: true,
      });
    }
    this.interviewerList = [..._interviewerList];
  }

  /**
   * 格式化数据，将当前日期之前的数据进行处理
   */
  private formatSchedule(_scheduleData: Array<any>): void {
    const nowTime = Math.ceil(new Date().getTime() / 1000);
    // tslint:disable-next-line:forin
    for (const i in _scheduleData) {
      // tslint:disable-next-line:forin
      for (const d in _scheduleData[i]['lists']) {
        const gridTime = Math.ceil(new Date(_scheduleData[i]['lists'][d]['date'] + ' ' + _scheduleData[i]['timer']).getTime() / 1000);
        if (nowTime > gridTime) {
          _scheduleData[i]['lists'][d]['type'] = 0;
        } else {
          _scheduleData[i]['lists'][d]['type'] = 1;
        }
      }
    }
    this.scheduleData = [..._scheduleData];
  }

  /**
   * 获取起止时间段内的每个日期
   * @private
   */
  getEveryDay(): void {
    const date = this.interviewDateArr[this.interviewDateIndex];
    const days = this.basisService.getDiffDate(this.common.date(date[0], 'Y-m-d'), this.common.date(date[1], 'Y-m-d'));
    this.selectDay = [...days];
  }
  /**
   * 退出编辑
   */
  exitEdit(): void {
    this.closeTip = false;
    const sourceData = JSON.parse(JSON.stringify(this.scheduleSourceData));
    // this.scheduleData = [...sourceData];
    this.formatSchedule(sourceData);
    this.create_schedule = [...[]];
  }

  /**
   * 获取每日可预约次数
   * @param scheduleData
   * @private
   */
  private getCountData(scheduleData: Array<object>): void {
    const countData: object = {};
    scheduleData.map((timer) => {
      timer['lists'].map((day) => {
        if (countData[day['date']] == undefined) {
          countData[day['date']] = 0;
        }
        if (day['info']['schedule_id'] != undefined) {
          countData[day['date']]++;
        }
        if (day['info']['number_of_user'] == 3) {
          countData[day['date']]--;
        }
      });
    });
    // console.log(scheduleData);
    // console.log(countData);
    this.countData = { ...countData };
  }

  /**
   * 检索数据
   * @param $event
   */
  select($event: any): void {
    this.getSchedule();
  }

  /**
   * 鼠标按下事件
   * @param timerIndex
   * @param dateIndex
   */
  mousedownEvent(timerIndex: number, dateIndex: number): void {
    if (this.interviewerList.every((item) => !item.checked)) {
      return;
    }
    const item = this.scheduleData[timerIndex]['lists'][dateIndex];
    if (Object.keys(item['info']).length == 0) {
      this.moveGridStatus = true;
    } else {
      this.moveGridStatus = false;
    }
    console.log(timerIndex);
    console.log(dateIndex);
    this.setGridStatus(timerIndex, dateIndex);
  }

  /**
   * 设置单元格状态
   * @param timerIndex
   * @param dateIndex
   */
  setGridStatus(timerIndex: number, dateIndex: number): void {
    const create_schedule = [...this.create_schedule];
    const del_schedule_id = [...this.del_schedule_id];
    const scheduleData = [...this.scheduleData];
    const scheduleSourceData = JSON.parse(JSON.stringify(this.scheduleSourceData));
    const sourceData = { ...scheduleSourceData[timerIndex]['lists'][dateIndex] }; // 老数据
    const hasOld = sourceData['info'].schedule_id != undefined; // 判断当前点的位置源数据是否存在旧数据
    const nowData = { ...scheduleData[timerIndex]['lists'][dateIndex] }; // 当前数据
    const timeItemElement = this.gridTime[timerIndex];
    const nowTime = Math.ceil(new Date().getTime() / 1000);
    // 判断当前数据中的日期时间是否完整
    const nowGridTime = Math.ceil(new Date(nowData['date'] + ' ' + timeItemElement).getTime() / 1000);
    if (nowTime > nowGridTime) {
      return;
    }

    if (this.moveGridStatus) {
      // 判断当前状态是未被选中的
      if (hasOld) {
        nowData['info'] = sourceData['info'];
        if (del_schedule_id.indexOf(sourceData['info'].schedule_id) > -1) {
          del_schedule_id.splice(del_schedule_id.indexOf(sourceData['info'].schedule_id), 1);
        }
      } else {
        for (const i of create_schedule) {
          if (i['schedule_date'] == nowData['date'] && i['schedule_time'] == timeItemElement) {
            return;
          }
        }
        nowData['info'] = {
          interviewer_uid: 0,
          schedule_date: nowData['date'],
          schedule_time: timeItemElement,
        };
        create_schedule.push(nowData['info']);
      }
    } else {
      if (nowData['info']['number_of_user'] != undefined && nowData['info']['number_of_user'] != 0) {
        this.disableEdit = true;
        this.contact = nowData['info']['headhunting_name'];
        return;
      } else {
        nowData['info'] = {};
        if (hasOld) {
          if (del_schedule_id.indexOf(sourceData['info'].schedule_id) == -1) {
            del_schedule_id.push(sourceData['info'].schedule_id);
          }
        } else {
          create_schedule.map((i, index) => {
            if (i['schedule_date'] == nowData['date'] && i['schedule_time'] == timeItemElement) {
              create_schedule.splice(index, 1);
            }
          });
        }
      }
    }
    scheduleData[timerIndex]['lists'][dateIndex] = { ...nowData };
    this.scheduleData = [...scheduleData];
    this.create_schedule = [...create_schedule];
    this.del_schedule_id = [...del_schedule_id];
  }

  /**
   * 鼠标移入
   * @param timerIndex
   * @param dateIndex
   */
  mouseenterEvent(timerIndex: number, dateIndex: number): void {
    this.timerI = timerIndex;
    this.dateI = dateIndex;
  }
  mouseleaveEvent(): void {
    this.timerI = null;
    this.dateI = null;
  }

  gridShowClick(timerIndex: number, dateIndex: number, item: any): void {
    if (JSON.stringify(item.info) == '{}') {
      return;
    }
    item['visible'] = true;
    for (const i of item.info) {
      if (this.checkData.schedule_id != undefined) {
        if (this.checkData.schedule_id.indexOf(i.schedule_id) == -1) {
          i.checked = false;
          item.allChecked = false;
          item.indeterminate = false;
        } else {
          i.checked = true;
          item.allChecked = this.checkData.allChecked;
          item.indeterminate = this.checkData.indeterminate;
        }
      } else {
        i.checked = false;
        item.allChecked = false;
        item.indeterminate = false;
      }
    }
  }

  // 时间 选择面试官 全部
  interviewerTimeAllChecked(item: any): void {
    item.indeterminate = false;
    if (item.allChecked) {
      item.info = item.info.map((item) => ({
        ...item,
        checked: true,
      }));
    } else {
      item.info = item.info.map((item) => ({
        ...item,
        checked: false,
      }));
    }
  }
  // 时间 选择面试官 单个
  interviewerTimeChecked(data: any): void {
    if (data.info.every((item) => !item.checked)) {
      data.allChecked = false;
      data.indeterminate = false;
    } else if (data.info.every((item) => item.checked)) {
      data.allChecked = true;
      data.indeterminate = false;
    } else {
      data.allChecked = false;
      data.indeterminate = true;
    }
  }
  // 确认时段
  ok(timeItem: any, item: any): void {
    item['visible'] = false;
    if (item.info.every((item) => !item.checked)) {
      this.checkData = {};
      this.check.emit({ event: 'check', target: this.checkData });
      return;
    }
    const interviewer_uid = [];
    const schedule_id = [];
    const interview_name = [];
    for (const i of item.info) {
      if (i.checked) {
        interviewer_uid.push(i.interviewer_uid);
        schedule_id.push(i.schedule_id);
        interview_name.push(i.interview_name);
      }
    }
    this.checkData = {
      date: item['date'],
      time: timeItem['timer'],
      name: interview_name,
      interviewer_uid,
      schedule_id,
      allChecked: item.allChecked,
      indeterminate: item.indeterminate,
    };
    this.check.emit({ event: 'check', target: this.checkData });
  }
  reset(timeItem: any, item: any): void {
    for (const i of item.info) {
      i.checked = false;
    }
    item.allChecked = false;
    item.indeterminate = false;
  }
}
